import React from 'react';
import PropTypes from "prop-types";
import SortHeader from "../../sortHeader";

function GenericTable(props) {
  const {
    tableData,
    cols,
    emptyMessage,
    defaultSortDirection,
    sortColumn,
    sortDirection,
    sortAction
  } = props;

  const renderCellContent = (tableRow, column, idx) => {
    if(column.onDisplay) {
      return column.onDisplay(tableRow, column, idx);
    } else {
      return tableRow[column.name];
    }
  }

  const renderCell = (tableRow, column, idx) => {
    const cellContent = renderCellContent(tableRow, column, idx);
    const key = `${column.name}-${idx}`;

    if (column.scope === 'row') {
      return <th key={key} scope='row' className='row-header'>{cellContent}</th>;
    } else if (column.isCheckbox) {
      return <td key={key} className='row-cell'>{cellContent}</td>;
    }  else {
      return <td key={key} className='row-cell'>{cellContent}</td>;
    }
  };

  const renderHeaderCell = (col, idx) => {
    const headerScope = col.scope || 'col';
    const key = `header-${idx}`;

    const changeAction = (newSortDirection) => {
      sortAction(newSortDirection, col.name);
    }

    let cellProps = {
      ...((sortDirection && sortColumn === col.name) && {'aria-sort': sortDirection}),
      ...(col.colspan && { colSpan: col.colspan }),
      ...(col.rowspan && { rowSpan: col.rowspan }),
      ...(col.label ?
        { scope: headerScope, className: col.hideLabel ? 'sr-hide' : 'column-header' } :
        { 'data-testid': 'empty-header'})
    };

    return col.label ? <th key={key} {...cellProps}>{col.sortable ? <SortHeader label={col.label} defaultSortDirection={(defaultSortDirection) ? (defaultSortDirection) : 'desc'} changeAction={(newSortDirection) => {changeAction(newSortDirection)}}/> : <div className='header-label'>{col.label}</div>}</th> : <td {...cellProps}></td>;
  };

  const dataRows = () => {
    return tableData.map((tableRow, idx) => (
      <tr key={`row-${idx}`}>{cols.map((col, colIdx) => renderCell(tableRow, col, colIdx))}</tr>
    ))
  }

  const emptyTable = () => {
    return (emptyMessage &&
      <tr key='row-0'>
        <td colSpan={cols.length} className='table-no-results'>
          <div className='no-results-message'>{emptyMessage}</div>
        </td>
      </tr>
    );
  }

  return (
    <table className="table">
      <thead className="table-header">
      <tr>{cols.map(renderHeaderCell)}</tr>
      </thead>
      <tbody>
      { (tableData.length > 0) ? dataRows() : emptyTable()}
      </tbody>
    </table>
  );
}

GenericTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  cols: PropTypes.array.isRequired,
  defaultSortDirection: PropTypes.string,
  sortAction: PropTypes.func
}

export default GenericTable;